import React from "react";
import { Container, Row, Col } from "reactstrap";
import AuditLogList from "./AuditLogList";

const AuditLogs = () => {
  return (
    <Container fluid className="p-0">
      <h1 className="page-title">Audit logs</h1>
      <Row>
        <Col lg="12" className="d-flex">
          <AuditLogList />
        </Col>
      </Row>
    </Container>
  );
};

export default AuditLogs;
